<ng-container *ngIf="{Applicant: (applicant$ | async), User: (user$ | async)}; let loggedInInfo;">
  <nav class="navbar fixed-top navbar-expand-lg navbar-dark bg-dark navbar-top">
    <div class="container">
      <a class="navbar-brand application-name" href="#"><img src="assets/images/logo.png" alt="FHP Trooper Badge image"> ATS</a>
      <div class="navbar-brand d-lg-none">
        <ng-container *ngIf="authenticationLocalStorageService.isApplicantLoggedIn()">
          {{loggedInInfo?.Applicant?.firstName}} {{loggedInInfo?.Applicant?.lastName}}
        </ng-container>
        <ng-container *ngIf="authenticationLocalStorageService.isUserLoggedIn()">
          {{loggedInInfo?.User?.firstName}} {{loggedInInfo?.User?.lastName}}
        </ng-container>
      </div>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNavDropdown">
        <ul class="navbar-nav me-auto">
          <ng-container *ngIf="authenticationLocalStorageService.isUserLoggedIn()">
            <ng-container *ngIf="checkPermission(loggedInInfo?.User, [permissionConstants.VIEW_USERS_ID])">

              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  User
                </a>
                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li><a class="dropdown-item" [routerLink]="['/users/list']" routerLinkActive="active">User Management</a></li>
                  <li><a class="dropdown-item" [routerLink]="['/users/user/Add']" routerLinkActive="active">User Create</a></li>
                </ul>
              </li>
            </ng-container>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Application
              </a>
              <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                <ng-container *ngIf="checkPermission(loggedInInfo?.User, [permissionConstants.VIEW_APPLICATIONS_ID])">
                  <li><a class="dropdown-item" [routerLink]="['/applications/list']" routerLinkActive="active">Active Applications</a></li>
                </ng-container>
                <li><a class="dropdown-item" [routerLink]="['/applications/applicants']" routerLinkActive="active">Applicants</a></li>
                <ng-container *ngIf="checkPermission(loggedInInfo?.User, [permissionConstants.VIEW_PAT_ROSTER_ID])">
                  <li><a class="dropdown-item" [routerLink]="['/applications/pat-roster']" routerLinkActive="active">PAT Roster</a></li>
                </ng-container>
                <li><a class="dropdown-item" [routerLink]="['/applications/polygraph-roster']" routerLinkActive="active">Polygraph Roster</a></li>
              </ul>
            </li>
            <ng-container *ngIf="checkPermission(loggedInInfo?.User, [permissionConstants.MANAGE_LOOKUP_LISTS_ID])">
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Administration
                </a>
                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li><a class="dropdown-item" [routerLink]="['/administration/pat-location']" routerLinkActive="active">PAT Location</a></li>
                  <li><a class="dropdown-item" [routerLink]="['/administration/pat-scheduled-event']" routerLinkActive="active">PAT Scheduled Event</a></li>
                  <li><a class="dropdown-item" [routerLink]="['/administration/polygraph-location']" routerLinkActive="active">Polygraph Location</a></li>
                  <li><a class="dropdown-item" [routerLink]="['/administration/psychologist']" routerLinkActive="active">Psychologist</a></li>
                </ul>
              </li>
            </ng-container>
            <ng-container *ngIf="checkPermission(loggedInInfo?.User, [permissionConstants.VIEW_REPORTS_ID])">
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" id="navbarDropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Reports
                </a>
                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li><a class="dropdown-item" (click)="getActiveApplicationsByPolygraher()">Active Applications By Polygrapher</a></li>
                  <li><a class="dropdown-item" [routerLink]="['/reports/applications-polygraph-by-race-and-gender']" routerLinkActive="active">Totals For Polygraph Test</a></li>
                  <li><a class="dropdown-item" [routerLink]="['/reports/applications-pat-by-race-and-gender']" routerLinkActive="active">Totals For PAT Test</a></li>
                  <li><a class="dropdown-item" [routerLink]="['/reports/applications-psychological-by-race-and-gender']" routerLinkActive="active">Totals For Psychological Test</a></li>
                  <li><a class="dropdown-item" [routerLink]="['/reports/applications-eye-exam-bgi']" routerLinkActive="active">Totals For Eye Exam</a></li>
                  <li><a class="dropdown-item" [routerLink]="['/reports/applications-physical-exam-bgi']" routerLinkActive="active">Totals For Physical Exam</a></li>
                  <li><a class="dropdown-item" [routerLink]="['/reports/applications-by-race-and-gender']" routerLinkActive="active">Total Applications By Race and Gender</a></li>
                  <li><a class="dropdown-item" [routerLink]="['/reports/applications-certified-leo-prior-military']" routerLinkActive="active">Certified LEO and Prior Military</a></li>
                  <li><a class="dropdown-item" [routerLink]="['/reports/applicants-count-by-created-date']" routerLinkActive="active">Applicants Count By Created Date</a></li>
                </ul>
              </li>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="authenticationLocalStorageService.isApplicantLoggedIn()">
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Applicant
              </a>
              <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                <li><a class="dropdown-item" [routerLink]="['/applicants/applications']" routerLinkActive="active">Applications</a></li>
                <li><a class="dropdown-item" [routerLink]="['/applicants/documents']" routerLinkActive="active">Documents</a></li>
                <li><a class="dropdown-item" [routerLink]="['/applicants/waivers']" routerLinkActive="active">Waivers</a></li>
                <li><a class="dropdown-item" [routerLink]="['/applicants/task']" routerLinkActive="active">Tasks</a></li>
                <li><a class="dropdown-item" [routerLink]="['/applicants/applicant-edit']" routerLinkActive="active">Supplemental Affidavit</a></li>
              </ul>
            </li>
          </ng-container>
        </ul>
        <div class="d-flex text-light">
          <div class="navbar-brand d-none d-lg-block">
            <ng-container *ngIf="authenticationLocalStorageService.isApplicantLoggedIn()">
              {{loggedInInfo?.Applicant?.firstName}} {{loggedInInfo?.Applicant?.lastName}}
            </ng-container>
            <ng-container *ngIf="authenticationLocalStorageService.isUserLoggedIn()">
              {{loggedInInfo?.User?.firstName}} {{loggedInInfo?.User?.lastName}}
            </ng-container>
          </div>
          <ul class="navbar-nav me-auto">
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Account
              </a>
              <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                <ng-container *ngIf="!(authenticationLocalStorageService.isUserLoggedIn()) && !(authenticationLocalStorageService.isApplicantLoggedIn())">
                  <ng-container *ngIf="isForUserClient()">
                    <li><a class="dropdown-item" [routerLink]="['/users/login']" routerLinkActive="active">User Login</a></li>
                  </ng-container>
                  <ng-container *ngIf="isForApplicantClient()">
                    <li><a class="dropdown-item" [routerLink]="['/applicants/login']" routerLinkActive="active">Applicant Login</a></li>
                    <li><hr class="dropdown-divider"></li>
                    <li><a class="dropdown-item" [routerLink]="['/applicants/create']" routerLinkActive="active">Create Account</a></li>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="authenticationLocalStorageService.isUserLoggedIn()">
                  <li><a class="dropdown-item" (click)="logoutUser()" routerLinkActive="active">Logout</a></li>
                  <li><a class="dropdown-item" [routerLink]="['/users/change-password']" routerLinkActive="active">Change Password</a></li>
                </ng-container>
                <ng-container *ngIf="authenticationLocalStorageService.isApplicantLoggedIn()">
                  <li><a class="dropdown-item" (click)="logoutApplicant()" routerLinkActive="active">Logout</a></li>
                  <li><a class="dropdown-item" [routerLink]="['/applicants/change-password']" routerLinkActive="active">Change Password</a></li>
                </ng-container>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</ng-container>
